<template>
  <nav
    class="shadow-none navbar navbar-main navbar-expand-lg border-radius-xl"
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :currentPage="currentRouteName" :textWhite="textWhite" />
      <div
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="this.$store.state.isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar"
      >

        <ul class="navbar-nav justify-content-end ms-auto">
          <li class="nav-item d-xl-none d-flex align-items-center">
            <a
              href="#"
              @click.prevent="toggleSidebar"
              class="nav-link mobile-menu-btn"
              id="iconNavbarSidenav"
              aria-label="Abrir menu"
            >
              <i class="fas fa-bars"></i>
            </a>
          </li>

          <li class="nav-item d-flex align-items-center ms-2">
            <a
              href="#"
              @click.prevent="handleLogout"
              class="px-0 nav-link font-weight-bold logout-btn"
              :class="textWhite ? textWhite : 'text-body'"
              :disabled="loading"
            >
              <i
                class="fa fa-sign-out-alt"
                :class="this.$store.state.isRTL ? 'ms-sm-2' : 'me-sm-1'"
              ></i>
              <span v-if="this.$store.state.isRTL" class="d-sm-inline d-none"
                >خروج</span
              >
              <span v-else class="d-sm-inline d-none">Sair</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import Breadcrumbs from "../Breadcrumbs.vue";
import { mapMutations, mapActions, mapGetters } from "vuex";
import { showConfirmAlert } from "@/utils/swal.js";

export default {
  name: "navbar",
  data() {
    return {
      loading: false,
    };
  },
  props: ["minNav", "textWhite"],
  created() {
    this.minNav;
  },
  methods: {
    ...mapMutations(["navbarMinimize"]),
    ...mapActions(["toggleSidebarColor", "logout"]),

    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },
    
    async handleLogout() {
      // Mostra confirmação antes de sair
      const result = await showConfirmAlert(
        'Sair do Sistema',
        'Tem certeza que deseja sair? Você precisará fazer login novamente para acessar o sistema.',
        'Sim, sair',
        'Cancelar'
      );

      if (!result.isConfirmed) {
        return;
      }

      this.loading = true;
      try {
        await this.logout();
        this.$router.push({ name: 'Sign In' });
      } catch (error) {
        console.error('Logout error:', error);
      } finally {
        this.loading = false;
      }
    },
  },
  components: {
    Breadcrumbs,
  },
  computed: {
    ...mapGetters(["isAuthenticated", "currentUser"]),
    currentRouteName() {
      return this.$route.name;
    },
  },
  updated() {
    const navbar = document.getElementById("navbarBlur");
    window.addEventListener("scroll", () => {
      if (window.scrollY > 10 && this.$store.state.isNavFixed) {
        navbar.classList.add("blur");
        navbar.classList.add("position-sticky");
        navbar.classList.add("shadow-blur");
      } else {
        navbar.classList.remove("blur");
        navbar.classList.remove("position-sticky");
        navbar.classList.remove("shadow-blur");
      }
    });
  },
};
</script>

<style scoped>
.mobile-menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  font-size: 1.1rem;
  color: #344767;
  background: rgba(23, 193, 232, 0.08);
  transition: background 0.2s ease, transform 0.15s ease, color 0.2s ease;
}

.mobile-menu-btn:hover,
.mobile-menu-btn:active {
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%);
  color: #fff;
  transform: scale(0.96);
}

.logout-btn {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 0 0.5rem !important;
}
</style>
